import React from "react";
import { RefreshCw, CloudOff, XCircle } from "lucide-react";
import "./ConnectionStatus.scss";

/**
 * Visual indicator for WebSocket connection state.
 * Only displays when not connected (connecting, reconnecting, or failed).
 */
const ConnectionStatus = ({
  status,
  reconnectAttempts,
  maxAttempts,
  onRetry,
}) => {
  // Don't show anything when connected
  if (status === "connected") {
    return null;
  }

  const getStatusContent = () => {
    switch (status) {
      case "connecting":
        return {
          Icon: RefreshCw,
          text: "Connecting...",
          className: "connecting",
          spinning: true,
        };
      case "reconnecting":
        return {
          Icon: RefreshCw,
          text: `Reconnecting... (${reconnectAttempts}/${maxAttempts})`,
          className: "reconnecting",
          spinning: true,
        };
      case "disconnected":
        return {
          Icon: CloudOff,
          text: "Disconnected",
          className: "disconnected",
          spinning: false,
        };
      case "failed":
        return {
          Icon: XCircle,
          text: "Connection failed",
          className: "failed",
          spinning: false,
        };
      default:
        return null;
    }
  };

  const content = getStatusContent();
  if (!content) {
    return null;
  }

  const { Icon } = content;

  return (
    <div className={`connection-status ${content.className}`}>
      <Icon
        size={18}
        className={`status-icon ${content.spinning ? "spinning" : ""}`}
      />
      <span className="status-text">{content.text}</span>
      {status === "failed" && (
        <button className="retry-button" onClick={onRetry}>
          Retry
        </button>
      )}
    </div>
  );
};

export default ConnectionStatus;
